import { alarmList, floorDetail, projectDetail, buildingDetail } from '@/api'
import { apiAlarmToUi } from '@/api/adapters'
import resource from '@/mock/store'

/** 与接口文档 alarm_type 一致：1 基站低电量 2 基站故障 3 基站离线 4 长时间驻留 */
export const ALARM_TYPE_LABELS = {
  1: '基站低电量',
  2: '基站故障',
  3: '基站离线',
  4: '长时间驻留'
}

export function alarmTypeLabel(type) {
  const key = Number(type)
  if (!Number.isFinite(key) || key <= 0) return '—'
  return ALARM_TYPE_LABELS[key] || `类型${key}`
}

async function fetchAlarmPage(params = {}) {
  const query = {
    page: params.page || 1,
    page_size: params.page_size || 10
  }
  if (params.keyword) query.keyword = params.keyword
  if (params.alarm_type) query.alarm_type = params.alarm_type
  if (params.project_id) query.project_id = params.project_id
  const res = await alarmList(query)
  const data = res.data || {}
  return {
    list: (data.list || []).map(apiAlarmToUi),
    total: data.total || 0,
    page: data.page || query.page,
    page_size: data.page_size || query.page_size
  }
}

export async function fetchAlarms(params = {}) {
  return fetchAlarmPage(params)
}

export async function loadAlarms(params = {}) {
  const result = await fetchAlarmPage(params)
  resource.alarms.splice(0, resource.alarms.length, ...result.list)
  return result
}

/** 解析报警详情所需图纸 url 与层级名称 */
export async function resolveAlarmLocation(alarm) {
  if (!alarm) return { imageUrl: '', projectName: '', buildingName: '', floorName: '' }
  let imageUrl = ''
  let projectName = ''
  let buildingName = ''
  let floorName = ''

  const tasks = []
  if (alarm.projectId > 0) {
    tasks.push(
      projectDetail({ id: alarm.projectId })
        .then(res => {
          const p = res.data || {}
          projectName = p.name || ''
          if (!alarm.floorId && !imageUrl && p.plan_image_url) {
            imageUrl = p.plan_image_url
          }
        })
        .catch(() => {})
    )
  }
  if (alarm.buildingId > 0) {
    tasks.push(
      buildingDetail({ id: alarm.buildingId })
        .then(res => {
          buildingName = (res.data && res.data.name) || ''
        })
        .catch(() => {})
    )
  }
  if (alarm.floorId > 0) {
    tasks.push(
      floorDetail({ id: alarm.floorId })
        .then(res => {
          const f = res.data || {}
          floorName = f.name || ''
          if (f.plan_image_url) imageUrl = f.plan_image_url
        })
        .catch(() => {})
    )
  }
  await Promise.all(tasks)
  return { imageUrl, projectName, buildingName, floorName }
}
